<template>
  <div>
    <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
        <StackedField label="Type">
          <span
            v-if="translatedHandlingType"
            :class="handlingTypeClasses"
            class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-bold"
          >
            {{ translatedHandlingType }}
          </span>
        </StackedField>
        <StackedField label="Gestionnaire" :value="translatedClaimHandler" />
        <StackedField label="Email gestionnaire" :value="claim.claimHandlerEmail" />
        <StackedField label="Point de vente" :value="claim.store.salesChannel" />
        <StackedField label="Mail SAV" :value="claim.claimManager" />
        <StackedField label="Entité remboursée">
          <span
            v-if="translatedRefundedEntity"
            class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-bold bg-green-100 text-green-800"
          >
            {{ translatedRefundedEntity }}
          </span>
        </StackedField>
        <StackedField v-if="claimResolved" label="Montant" :value="formatPrice(claim.refundedAmount)" />
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";
import { mapGetters } from "vuex";

export default {
  components: { StackedField },

  props: ["claim"],

  computed: {
    ...mapGetters("claims", ["claimResolved", "handlingTypeStyle"]),

    translatedHandlingType() {
      return this.claim.handlingType ? this.$t(`claim.handling_type.${this.claim.handlingType}`) : null;
    },

    handlingTypeClasses() {
      return this.claim?.handlingType
        ? `${this.handlingTypeStyle(this.claim.handlingType)} font-bold text-white`
        : null;
    },

    translatedClaimHandler() {
      return this.claim.claimHandler ? this.$t(`claim.claim_handler.${this.claim.claimHandler}`) : null;
    },

    translatedRefundedEntity() {
      return this.claim.refundedEntity ? this.$t(`claim.refunded_entity.${this.claim.refundedEntity}`) : null;
    },
  },
  methods: {
    formatPrice,
  },
};
</script>
